window.themeScopedOptions = (() => {
  const operators = ['::', '!!'];

  const parse = (value) => {
    const source = String(value);
    const candidates = operators.flatMap((operator) => {
      const matches = [];
      let index = source.indexOf(operator);

      while (index !== -1) {
        matches.push({ index, operator });
        index = source.indexOf(operator, index + operator.length);
      }

      return matches;
    }).sort((a, b) => a.index - b.index);

    for (const candidate of candidates) {
      const scopes = source.slice(0, candidate.index).split(',').map((scope) => scope.trim());
      const label = source.slice(candidate.index + candidate.operator.length).trim();

      if (label && scopes.length && scopes.every(Boolean)) {
        return { label, operator: candidate.operator, scopes };
      }
    }

    return null;
  };

  const getMode = (values) => {
    for (const value of values) {
      const parsed = parse(value);
      if (parsed) return parsed.operator;
    }

    return null;
  };

  const getPresentation = (value, mode) => {
    const parsed = parse(value);
    return parsed && mode ? { ...parsed, operator: mode } : { label: String(value), operator: null, scopes: [] };
  };

  const matches = (presentation, previousValues) => {
    if (!presentation.operator) return true;
    const selectedLabels = previousValues.map((value) => getPresentation(value, presentation.operator).label.trim().toLowerCase());
    return presentation.scopes.some((scope) => selectedLabels.includes(scope.toLowerCase()));
  };

  return { getMode, getPresentation, matches };
})();
